export var limitNotificationBadgeCount = function limitNotificationBadgeCount(count, max) {
  return count > max ? "".concat(max, "+") : "".concat(count);
};